import {
  Connect, ConnectEventHandlers, ConnectOptions, ConnectDoneEvent,
  ConnectCancelEvent, ConnectErrorEvent, ConnectRouteEvent
} from 'connect-web-sdk';
import { SetStateAction, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { httpGetAsync, httpPostAsync } from '../../../Http/HttpClient';
import '../../../App.scss';

export default function FinicityPortalLogin() {

  const [screenText, setText] = useState("Loading Bank Verification...");

  const connectEventHandlers: ConnectEventHandlers = {
    onDone: (event: ConnectDoneEvent) => { DoneConnectClient(event); },
    onCancel: (event: ConnectCancelEvent) => { CloseConnectClient(event); },
    onError: (event: ConnectErrorEvent) => { ErrorConnectClient(event); },
    onRoute: (event: ConnectRouteEvent) => { RouteConnectClient(event); },
    onUser: (event: any) => { OnUserConnectClient(event); },
    onLoad: () => { console.log('loaded'); }
  };

  const params = useParams();
  const portalLinkId = (params as any)?.customerPortalLinkId;

  const OnUserConnectClient = async(event: any) => {
    console.log(event);

    const body = {
      eventType: event.action
    };
    // Post the response to the OpenApi
    const response = await httpPostAsync(`finicity/webhook/${portalLinkId}?customerPortalLinkId=${portalLinkId}`, body);
  }

  const RouteConnectClient = async(event: ConnectRouteEvent) => {
    console.log(event);

    // This is the call that sends the "done".. it's the last "screen"
    const body = {
      eventType: event.screen
    };
    // Post the response to the OpenApi
    const response = await httpPostAsync(`finicity/webhook/${portalLinkId}?customerPortalLinkId=${portalLinkId}`, body);
  }


  const ErrorConnectClient = async(event: ConnectErrorEvent) => {
    console.log(event);
    Connect.destroy();
    setText("Bank Verification did not complete. You may need to contact your salesperson for another link...");

    const body = {
      eventType: "Error"
    };
    // Post the response to the OpenApi
    const response = await httpPostAsync(`finicity/webhook/${portalLinkId}?customerPortalLinkId=${portalLinkId}`, body);
  }

  const CloseConnectClient = async(event: ConnectCancelEvent) => {
    console.log(event);
    Connect.destroy();
    setText("Bank Verification did not complete. You may need to contact your salesperson for another link...");

    const body = {
      eventType: "Canceled"
    };
    // Post the response to the OpenApi
    const response = await httpPostAsync(`finicity/webhook/${portalLinkId}?customerPortalLinkId=${portalLinkId}`, body);
  }

  const DoneConnectClient = async(event: ConnectDoneEvent) => {
    console.log(event);
    Connect.destroy();
    setText("Thank you. You will be contacted shortly.");

    const body = {
      eventType: "Complete"
    };
    // Post the response to the OpenApi
    const response = await httpPostAsync(`finicity/webhook/${portalLinkId}?customerPortalLinkId=${portalLinkId}`, body);
  }

  useEffect(() => {
    const functionWrapper = async () => {
      const response = await httpGetAsync(`finicity/getFinicityLink/${portalLinkId}?customerPortalLinkId=${portalLinkId}`);

      if (response && (response as Response).ok) {
        const linkValue: { link: string } = await response.json();
        Connect.destroy();
        Connect.launch(linkValue.link, connectEventHandlers);
      }
      else{
        setText("This Link has expired, please contact your salesperson.");        
      }

      const body = {
        eventType: "Started"
      };
      // Post the response to the OpenApi
      const postResponse = await httpPostAsync(`finicity/webhook/${portalLinkId}?customerPortalLinkId=${portalLinkId}`, body);
    }

    if (portalLinkId) {
      functionWrapper();
    }

  }, [params]);

  return (
    <div className="container">
      <div className="centered-text" style={{marginLeft: '20px', marginRight: '20px'}}>{screenText}</div>
    </div>
  )

}
